export const specialMenu = {
    crypto: '数字货币',
    virtualCard: '虚拟卡',
}
export const homeOneModule = {
    title: '安全稳定企业服务',
    subTitle: '优质服务值得您信赖',
    descList: [
        {
            content: '10 年服务经验积累'
        },
        {
            content: '9 种安全保障'
        },
        {
            content: '8 种服务场景'
        },
    ]
}
export const homeTwoModule = {
    title: '全球资产一站式管理',
    subTitle: '使用UBPay，您可以在单一平台上管理稳定币和法币'
}
export const homeThreeModule = {
    title: 'UBPay 全球商业活动最佳伙伴',
    subTitle: '支持稳定币即时转化，毫秒级转换，不必再切换多个系统，减少市场波动风险，保障资产价值'
}
export const homeFourModule = {
    title: '便捷、安全、高效的全球虚拟卡业务',
    subTitleList: [
        {
            title: '高效开卡，极速体验',
            subTitle: '支持秒速开卡，即开即用，省时省力',
            img: require('@/assets/imgs/home/gaoxiao.png')
        },
        {
            title: '技术领先，安全保障',
            subTitle: '稳定可靠的技术架构，卡片管理和支付流程保驾护航',
            img: require('@/assets/imgs/home/jishu.png')
        },
        {
            title: '币种多样，交易便捷',
            subTitle: '提供USD、EUR、GBP等多种卡片，满足特定币种支付需求，有效降低汇损',
            img: require('@/assets/imgs/home/bizhong.png')
        },
    ]
}
export const appDownload = {
    title: '下载app',
    desc: 'UBPay可在ios和Android上作为移动应用程序使用',
}
export const footerUbpayDesc = {
    content: 'PACIFIC BANK 和 EAST BANK 联合成立 EAST CARD 公司，全球总部位于纽约和中国香港，' +
        '分别推出了 UB CARD 和 UB PAY，在新加坡设有分支机构。' +
        '与多家国际级银行达成战略合作关系，推动支付业务在亚太区域的发展。'
}
export const footerMenu = [
    {
        name: "产品与服务",
        router: "index",
        url: "",
        childList: [
            {
                name: "多种币种钱包",
                url: "multiWalletAndCcy",
            },
            {
                name: "转换稳定币",
                url: "transformCcy",
            },
            {
                name: "虚拟银行卡",
                url: "footerVirtualCard",
            },
            {
                name: "付款和取现",
                url: "payment",
            },
            {
                name: "安全",
                url: "security",
            },
        ]
    },
    {
        name: "关于我们",
        router: "scienceResult",
        url: "",
        childList: [
            {
                name: "关于UBPay",
                url: "aboutUBPay",
            },
            {
                name: "联系我们",
                url: "contactUs",
            }
        ]
    },
    {
        name: "政策与法规",
        router: "productCenter",
        url: "",
        childList: [
            // {
            //     name: "使用条款",
            //     url: "termsOfUse",
            // },
            {
                name: "隐私政策",
                url: "privacyPolicy",
            },
            {
                name: "帮助中心",
                url: "helpCenter",
            }
        ]
    },
    {
        name: "APP",
        router: "newsCenter",
        url: "",
        childList: [
            {
                name: "APP下载",
                url: "appDownload",
            }
        ]
    }
]
export const cryptoOneModule = {
    title: '支持多币种多公链',
    subTitle: '我们支持多币种多公链，让您在一个平台上随心随意管理多条公链的数字货币。无论是以太坊还是波场，都可以在我们的平台上轻松切换，即时交易。'
}
export const cryptoTwoModule = {
    title: '稳定币换法币',
    subTitle: 'UBPay稳定币即时转化，毫秒级转换，不必再切换多个系统，减少市场波动风险，保障资产价值。'
}
export const cryptoThreeModule = {
    title: '专业的团队为您的加密货币交易提供保障',
    threeList: [
        {
            content: '低费用'
        },
        {
            content: '去中心化'
        },
        {
            content: '支持多条公链'
        },
        {
            content: '及时结算'
        },
        {
            content: '稳定币兑换'
        },
        {
            content: '降低欺诈风险'
        },
        {
            content: '全球充提币'
        },
        {
            content: '7×24小时全天候客服支持'
        },
    ]
}
export const virtualCardOneModule = {
    label: 'Mastercard&Discover® Global Network双通道',
    title: '全面覆盖全球线上线下消费全场景，满足您多样化的支付需求',
    subTitleList: [
        {
            img: require('@/assets/imgs/home/gaoxiao2.png'),
            title: "高效开卡，极速体验",
            content: "无限等待，支持秒速开通 Mastercard&Discover虚拟卡，即开即用，开启全球支付之旅"
        },
        {
            img: require('@/assets/imgs/home/jishu2.png'),
            title: "技术领先，安全保障",
            content: "稳定可靠的技术架构，卡片管理和支付流程保驾护航"
        },
        {
            img: require('@/assets/imgs/home/bizhong2.png'),
            title: "币种多样，交易便捷",
            content: "提供USD、EUR、GBP等多种卡片，满足特定币种支付需求，有效降低汇损"
        },
        {
            img: require('@/assets/imgs/home/baozhang.png'),
            title: "匿名无忧，隐私至上",
            content: "虚拟卡提供高度匿名性，无需提供真实身份信息即可轻松获取，有效保护您的个人隐私"
        }
    ]
}
export const virtualCardTwoModule = {
    title: 'Discover和Mastercard两大卡组',
    cardGroup: [
        {
            name: 'Discover',
            descList: [
                {
                    content: '优惠的产品定价，便捷的产品体验'
                },
                {
                    content: '多场景支持，可反复使用'
                },
                {
                    content: 'Shared limits for centralized enterprise card control'
                }
            ]
        },
        {
            name: 'Mastercard',
            descList: [
                {
                    content: '多场景支持，广泛的商户接受度'
                },
                {
                    content: '安全性和欺诈保护'
                },
                {
                    content: '良好的客户服务'
                }
            ]
        }
    ]
}
export const virtualCardThreeModule = {
    title: '极速开卡，轻松管理',
    openMgtList: [
        {
            title: '极速开卡',
            content: '无需等待，支持秒速开通Mastercard&DisCover虚拟卡，即开即用，开启全球之旅'
        },
        {
            title: '币种多样',
            content: '提供USD、EUR、GBP等多种卡片，满足特定币种支付需求，有效降低汇损'
        },
        {
            title: '技术领先，稳定可靠',
            content: '稳定可靠的技术架构，卡片管理和支付流程保驾护航'
        },
        {
            title: '管理方便',
            content: '配套APP线上多卡统一管理，方便您随时查看和管理卡片信息'
        },
        {
            title: '全球支付',
            content: '支持主流支付平台线上支付，包括支付宝、微信支付、轻松应对跨境电商、海淘购物，线下支付贴心服务'
        },
        {
            title: '贴心服务，全程保障',
            content: '工作日全天候客户资讯服务，及时解决您的用卡问题'
        }
    ]
}
export const virtualCardFourModule = {
    title: '全方位守护您的隐私与安全',
    privacyAndSecurityList: [
        {
            img: require('@/assets/imgs/home/rq.png'),
            title: "支持匿名，隐私至上",
            content: "虚拟卡申请高度匿名性，无需提供真实身份信息即可在线申请，有效保护您的个人隐私。"
        },
        {
            img: require("@/assets/imgs/home/aq.png"),
            title: "安全可靠，严控风险",
            content: "专属号段，每次开卡均生成唯一卡号，三方绑定操作多重验证，避免卡信息泄露风险，保障您的资金安全。"
        },
        {
            img: require("@/assets/imgs/home/ed.png"),
            title: "灵活使用，额度可控",
            content: "支持按需自定义充值额度，严格控制支出额度，避免过度消费和盗刷风险。"
        },
    ]
}
export const popup = {
    prContent: {
        regulationsOne: {
            subTitle: '1，简介',
            content: '本平台重视您的隐私，并致力于保护您的个人信息安全。本文《隐私条款》将说明我们在您访问我们的网站、使用我们的服务或与我们互动时，如何收集、使用、披露和保护您的信息。'
        },
        regulationsTwo: {
            subTitle: '2，我们收集的信息',
            content: '我们可能收集以下类型的信息：',
            list: [
                {
                    content: '个人身份信息（如姓名、身份证号、地址、电话号码、电子邮件）'
                },
                {
                    content: '财务信息（如银行账户、钱包地址、交易记录）'
                },
                {
                    content: '技术数据（如IP地址、浏览器类型、操作系统）'
                },
                {
                    content: '使用数据（如登录记录、点击行为、偏好设置）'
                },
                {
                    content: 'KYC信息（了解您的客户相关文件）'
                }
            ]
        },
        regulationsThree: {
            subTitle: '3，我们如何使用您的信息',
            content: '我们使用您的信息以：',
            list: [
                {
                    content: '提供、维护和改进我们的服务'
                },
                {
                    content: '验证您的身份并履行法律义务'
                },
                {
                    content: '处理交易和管理账户'
                },
                {
                    content: '防止欺诈、洗钱和非法活动'
                },
                {
                    content: '与您沟通有关服务更新和促销活动'
                }
            ]
        },
        regulationsFour: {
            subTitle: '4，信息共享与披露',
            content: '我们不会出售您的个人信息。但在以下情况下，我们可能会共享您的信息：',
            list: [
                {
                    content: '与关联公司及服务提供商签署保密协议的前提下共享'
                },
                {
                    content: '根据法律要求与监管机构和执法机关共享'
                },
                {
                    content: '经您同意后与业务合作伙伴共享用于运营或促销目的'
                }
            ]
        },
        regulationsFive: {
            subTitle: '5，数据保留',
            content: '我们仅在达成本政策所述目的或遵守法律义务所需的期限内保留您的个人信息。'
        },
        regulationsSex: {
            subTitle: '6，数据安全',
            content: '我们采取适当的技术和组织措施，以防止您的个人数据被未经授权访问、披露、修改或销毁。'
        },
        regulationsSeven: {
            subTitle: '7，您的权利',
            content: '您有权：',
            list: [
                {
                    content: '访问和更正您的个人信息'
                },
                {
                    content: '要求删除或限制对您信息的处理'
                },
                {
                    content: '随时撤回您的同意'
                },
                {
                    content: '向数据保护机构投诉'
                }
            ]
        },
        regulationsEight: {
            subTitle: '8，Cookies与追踪技术',
            content: '我们使用Cookies和类似技术来提升您的使用体验，分析网站使用情况，并提供个性化内容。'
        },
        regulationsNine: {
            subTitle: '9，国际数据传输',
            content: '您的信息可能在您所在国家以外的司法管辖区进行处理和存储。我们将确保采取适当的保护措施。'
        },
        regulationsTen: {
            subTitle: '10，政策变更',
            content: '我们保留随时更新本隐私条款的权利。如有重大变更，我们将通过网站或其他方式通知您。'
        }
    },
    helpCenterList: [
        {
            title: '1，如何注册成为UBPay的用户？',
            content: '下载UBPay的APP，打开APP之后点击“注册”按钮，您可以用电子邮箱注册账号。当收到系统发送的验证码邮件之后，输入邮件验证码、密码，勾选用户注册协议，提交之后即可创建UBPay账号。'
        },
        {
            title: '2，是否必须完成实名认证(KYC)才能使用UBPay？',
            content: '数字资产充值，部分地区可在未实名的情况下使用；如果需要申请银行卡服务，你必须完成KYC认证。KYC包括提交身份证明文件(例如：身份证、护照、驾照)，审核时间通常为1~12小时之内。'
        },
        {
            title: '3，有账号更改邮箱服务吗？',
            content: '有的，在个人中心有更改登录邮箱的功能，输入新邮箱，提交系统发送的邮件验证码之后，可以更改登录邮箱。'
        },
        {
            title: '4，忘记密码怎么办？',
            content: '在登录页面点击“忘记密码”，输入登录邮箱之后，会收到系统发送的邮件验证码，输入验证码之后可以重置密码。但是频繁重置可能被系统检测到从而进行风控。'
        },
        {
            title: '5，一个人可以注册多个UBPay的账号吗？',
            content: '出于风控考虑，我们不建议用户注册多个UBPay的账号。'
        },
        {
            title: '6，可以申请哪些银行卡？',
            content: '我们提供两大发卡机构Mastercard和Discover® Global Network的银行卡。卡片分为实体卡和虚拟卡，虚拟卡即开即用，方便UBPay用户选择。'
        },
        {
            title: '7，什么是虚拟银行卡？',
            content: '虚拟银行卡是UBPay为用户提供的两大发卡机构的银行卡，虚拟银行卡是一种没有实体卡片的银行卡，以数字卡片的形式存在，包含卡号、有效期、CVV等信息。用户可以使用虚拟卡在网上进行支付，虚拟卡与实体卡具备相似功能，但使用更便捷、匿名性更高、安全性更强。'
        },
        {
            title: '8，虚拟银行卡支持哪些用途？',
            content: 'UBPay虚拟银行卡可应用于：绑定第三方支付平台支付宝、微信支付、ApplePay、GooglePay、PayPal等钱包进行线上支付。也可以用于在线下部分ATM机上进行取现。'
        },
        {
            title: '9，虚拟银行卡支持哪些币种？',
            content: '虚拟银行卡币种包括：美元（USD）、欧元（EUR）、英镑（GBP）等。我们还提供多币种虚拟卡，支持根据消费地自动换汇扣款，避免货币转换手续费。'
        },
        {
            title: '10，一张虚拟银行卡可以使用多久？',
            content: 'UBPay虚拟银行卡有效期通常为1~2年不等，当到了一年期之后可以续卡一年。有效期通常在卡片详情中明确显示。'
        }
    ],
    tfVersionDownloadTitle: 'TF版本下载指南',
    tfVersionDownload: [
        {
            content: '1，下载 TestFlight：打开 iOS 设备上的 App Store，搜索 “TestFlight”，找到 TestFlight 应用并点击 “获取” 进行下载和安装。'
        },
        {
            content: '2，获取邀请：开发者会在 App Store Connect 中创建公共测试链接或向特定用户发送邀请邮件。用户会收到包含邀请链接的邮件，或者从其他渠道获得开发者提供的邀请链接。'
        },
        {
            content: '3，使用邀请链接：点击邀请链接（https://testflight.apple.com/join/UVTZakva），系统会自动打开 TestFlight 应用。如果未自动打开，可手动打开 TestFlight。'
        },
        {
            content: '4，安装应用：在 TestFlight 应用中，点击 “开始测试” 按钮，然后点击 “安装” 按钮，等待应用下载和安装完成。安装完成后，即可在主屏幕上找到并打开应用进行使用。'
        }
    ]
}
export const aboutUBPay = {
    title: '关于我们',
    content: {
        subTitle: 'UBPay 是一家专注于构建新一代数字货币支付系统的金融科技公司，致力于为全球商户和个人提供安全、高效、合规的加密货币收付款解决方案。',
        content: '我们赋能企业接入数字资产世界，实现跨境支付自由、稳定币结算透明化、以及高频交易的稳定支持。我们的平台支持主流公链(如 Bitcoin、Ethereum、TRON 等)上的收款、换汇、结算、自动清算、KYC 出金等一站式服务，旨在打造面向未来的合规数字支付基础设施。'
    }
}
export const contactUs = {
    title: '联系我们',
    contactEmailMethod: '您可以通过邮箱联系我们',
    contactMediumMethod: '我们的社交媒体',
    contactForm: {
        title: '需要咨询我们，请留下您的联系方式',
        name: '您的姓名',
        email: '您的邮箱',
        message: '您的留言',
        submit: '提交'
    }
}

